// VM Performance — centralized content data (Portuguese).
// All texts preserved from original site.

export const BRAND = {
  name: "VM Performance",
  professional: "Vagner Milioli",
  cref: "CREF: PR-049384",
  instagram: "vagnermiliolipersonal",
  instagramUrl: "https://www.instagram.com/vagnermiliolipersonal/",
  whatsapp: "5545998135019",
  whatsappDisplay: "+55 45 99813-5019",
  gymName: "Academia Estimoove",
  gymAddress: "Av. República Argentina, 4194 — Panorama, Foz do Iguaçu - PR",
  googleReviewUrl: "https://g.page/r/CXgyWIlOqXiwEAE/review",
};

export const WHATSAPP_LINK = (msg) =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(msg)}`;

export const MEDIA = {
  logo: "/logo-vm-performance.png",
  trainerPortrait:
    "https://customer-assets.emergentagent.com/job_vm-training-portal-1/artifacts/7aoxpw8f_eu%20de%20preto.png",
  // Gym interior - Academia Estimoove
  gymEnv:
    "https://customer-assets.emergentagent.com/job_vm-training-portal-1/artifacts/190teyg8_estimooove%201.webp",
  // Hero online - remote/digital fitness theme
  onlineHero:
    "https://images.unsplash.com/photo-1518611012118-696072aa579a?auto=format&fit=crop&w=1800&q=80",
  // Personal Trainer — real transformations
  beforeAfterMan1Before:
    "https://customer-assets.emergentagent.com/job_vm-training-portal-1/artifacts/8nzpkwuv_Thiago%20Zito%20ANTES.png",
  beforeAfterMan1After:
    "https://customer-assets.emergentagent.com/job_vm-training-portal-1/artifacts/1v9giioo_Thiago%20Zito%20DEPOIS.png",
  beforeAfterSilviaBefore:
    "https://customer-assets.emergentagent.com/job_vm-training-portal-1/artifacts/mpyav77j_silvia%20antes.jpeg",
  beforeAfterSilviaAfter:
    "https://customer-assets.emergentagent.com/job_vm-training-portal-1/artifacts/6rcf6nob_Silvia%20Ribeiro%20DEPOIS.png",
  // Consultoria Online — real transformations
  beforeAfterMan2Before:
    "https://customer-assets.emergentagent.com/job_vm-training-portal-1/artifacts/chewint2_Vagner%20Milioli%20ANTES.png",
  beforeAfterMan2After:
    "https://customer-assets.emergentagent.com/job_vm-training-portal-1/artifacts/e8fruc9w_Vagner%20Milioli%20DEPOIS.png",
  beforeAfterJoaoBefore:
    "https://customer-assets.emergentagent.com/job_vm-training-portal-1/artifacts/rk9jts6z_Joao%20Victor%20antes.png",
  beforeAfterJoaoAfter:
    "https://customer-assets.emergentagent.com/job_vm-training-portal-1/artifacts/ndp3642x_Joao%20Victor%20DEPOIS.png",
  // Nova transformação cliente
  beforeAfterClientBefore:
    "https://customer-assets.emergentagent.com/job_vm-training-portal-1/artifacts/rk9jts6z_Joao%20Victor%20antes.png",
  beforeAfterClientAfter:
    "https://customer-assets.emergentagent.com/job_vm-training-portal-1/artifacts/ndp3642x_Joao%20Victor%20DEPOIS.png",
};

export const ABOUT_PARAGRAPHS = [
  "Graduado em Educação Física e Personal Trainer, meu foco é unir o que há de mais atual na ciência do exercício à realidade da sua rotina. Acredito que a constância sempre vence a motivação e, por isso, foco em ajudar você a integrar o movimento na sua vida de forma inteligente e prazerosa.",
  "Meu trabalho aqui é guiar você pelo caminho mais seguro e eficiente para alcançar sua melhor versão, com um acompanhamento profissional de verdade.",
];

// Personal Trainer Plans (presencial)
export const PERSONAL_PLANS = [
  {
    id: "bronze",
    name: "Bronze",
    frequency: "2x por semana",
    sessions: "8 aulas no mês",
    features: [
      "Treinos supervisionados",
      "8 aulas no mês",
      "Avaliação física periódica",
    ],
    highlight: false,
    badge: null,
  },
  {
    id: "prata",
    name: "Prata",
    frequency: "3x por semana",
    sessions: "12 aulas no mês",
    features: [
      "Treinos supervisionados",
      "12 aulas no mês",
      "Avaliação física periódica",
    ],
    highlight: false,
    badge: null,
  },
  {
    id: "ouro",
    name: "Ouro",
    frequency: "4x por semana",
    sessions: "16 aulas no mês",
    features: [
      "Treinos supervisionados",
      "16 aulas no mês",
      "Avaliação física periódica",
    ],
    highlight: true,
    badge: "Recomendado",
  },
  {
    id: "black",
    name: "Black",
    frequency: "5x por semana",
    sessions: "20 aulas no mês",
    features: [
      "Treinos supervisionados",
      "20 aulas no mês",
      "Avaliação física periódica",
    ],
    highlight: true,
    badge: "Máximo Resultado",
  },
];

// Online Plans (consultoria)
export const ONLINE_PLANS = [
  {
    id: "essencial",
    name: "Essencial",
    period: "Mensal · 1 mês",
    price: "R$ 210",
    priceSuffix: "/mês",
    pix: "R$ 189",
    pixNote: "no PIX/Boleto (10% off)",
    paymentLinks: {
      pix: "https://www.asaas.com/c/c0r1v80oh27iludb",
      card: "https://www.asaas.com/c/gmqt9lretvzzl0ni",
    },
    features: [
      "Treino Personalizado",
      "Protocolo Alimentar",
      "App MFIT",
      "Suporte WhatsApp",
      "Ajustes de treino mensal",
      "Acompanhamento mensal",
      "Vídeos Demonstrativos",
      "Somente à vista",
    ],
    badge: null,
  },
  {
    id: "performance",
    name: "Performance",
    period: "Trimestral · 3 meses · R$ 170/mês",
    price: "R$ 510",
    priceSuffix: "/total",
    pix: "R$ 459",
    pixNote: "no PIX/Boleto (10% off)",
    paymentLinks: {
      pix: "https://www.asaas.com/c/5w5vmunsmc1e7iy9",
      card: "https://www.asaas.com/c/l7ixtyxa3ljqkxd3",
    },
    features: [
      "Treino Personalizado",
      "Protocolo Alimentar",
      "App MFIT",
      "Suporte WhatsApp",
      "Ajustes de treino quinzenal",
      "Acompanhamento quinzenal",
      "Vídeos Demonstrativos",
      "Parcelável em até 3x",
    ],
    badge: null,
  },
  {
    id: "elite",
    name: "Elite",
    period: "Semestral · 6 meses · R$ 160/mês",
    price: "R$ 960",
    priceSuffix: "/total",
    pix: "R$ 864",
    pixNote: "no PIX/Boleto (10% off)",
    paymentLinks: {
      pix: "https://www.asaas.com/c/004mc4gkfgss1frp",
      card: "https://www.asaas.com/c/la2lidm5cbqtozi6",
    },
    features: [
      "Treino Personalizado",
      "Protocolo Alimentar",
      "App MFIT",
      "Suporte WhatsApp",
      "Ajustes de treino semanal",
      "Acompanhamento semanal",
      "Suporte prioritário",
      "Vídeos Demonstrativos",
      "Parcelável em até 3x",
    ],
    badge: "Mais Popular",
  },
  {
    id: "prime",
    name: "Prime",
    period: "Anual · 12 meses · R$ 150/mês",
    price: "R$ 1.800",
    priceSuffix: "/total",
    pix: "R$ 1.620",
    pixNote: "no PIX/Boleto (10% off)",
    paymentLinks: {
      pix: "https://www.asaas.com/c/wb3mk4cve4pj4u3i",
      card: "https://www.asaas.com/c/4eagrslefhoajc2m",
    },
    features: [
      "Treino Personalizado",
      "Protocolo Alimentar",
      "App MFIT",
      "Suporte WhatsApp",
      "Ajustes de treino semanal",
      "Acompanhamento semanal",
      "Suporte prioritário",
      "Vídeo chamada mensal (30 min)",
      "Vídeos Demonstrativos",
      "Parcelável em até 3x",
    ],
    badge: null,
  },
];

export const ONLINE_BENEFITS = [
  {
    icon: "Dumbbell",
    title: "Treino Personalizado",
    description:
      "Planilha de treino exclusiva montada de acordo com seus objetivos e rotina.",
  },
  {
    icon: "Smartphone",
    title: "App MFIT",
    description:
      "Seu treino fica disponível direto no celular, com execução guiada.",
    link: { label: "Baixar App MFIT", href: "https://www.mfitpersonal.com.br/download" },
  },
  {
    icon: "Salad",
    title: "Protocolo Alimentar",
    description:
      "Orientações nutricionais práticas para potencializar seus resultados.",
  },
  {
    icon: "MessageCircle",
    title: "Suporte WhatsApp",
    description: "Tire dúvidas diretamente comigo pelo WhatsApp.",
  },
  {
    icon: "TrendingUp",
    title: "Acompanhamento",
    description:
      "Análise de evolução com ajustes constantes para maximizar resultados.",
  },
  {
    icon: "PlayCircle",
    title: "Vídeos Demonstrativos",
    description: "Execução correta de cada exercício para treinar com segurança.",
  },
];

export const PERSONAL_BENEFITS = [
  {
    icon: "Activity",
    title: "Avaliação Física",
    description:
      "Análise de composição corporal para a melhor estratégia inicial.",
  },
  {
    icon: "Target",
    title: "Treino Personalizado",
    description:
      "Cada exercício é planejado especificamente para você, respeitando seu nível e objetivos.",
  },
  {
    icon: "UserCheck",
    title: "Acompanhamento Exclusivo",
    description:
      "Atenção individual em todas as sessões, correção de postura e técnica em tempo real.",
  },
  {
    icon: "Trophy",
    title: "Resultados Garantidos",
    description:
      "Método comprovado com progressão constante e ajustes estratégicos no seu treino.",
  },
  {
    icon: "Flame",
    title: "Motivação Constante",
    description:
      "Suporte e incentivo para você superar seus limites a cada treino.",
  },
  {
    icon: "Clock",
    title: "Flexibilidade de Horários",
    description:
      "Escolha os melhores dias e horários que se encaixam na sua rotina.",
  },
];

export const HOW_IT_WORKS = [
  {
    n: "01",
    title: "Anamnese",
    description:
      "Formulário detalhado sobre rotina, histórico e objetivos para mapear seu ponto de partida.",
  },
  {
    n: "02",
    title: "Montagem do Plano",
    description:
      "Elaboração personalizada do treino e protocolo alimentar baseado em evidências.",
  },
  {
    n: "03",
    title: "Acompanhamento",
    description:
      "Suporte constante com ajustes para otimizar resultados a cada semana.",
  },
];

export const PERSONAL_CONDITIONS = [
  "Prestação de serviços e horários assegurados legalmente através de CONTRATO DE ADESÃO.",
  "Planos contínuos com RENOVAÇÃO MENSAL. Os valores da tabela são referentes a cada mês pago.",
  "Para preservar seu progresso, as aulas são NÃO ACUMULATIVAS e devem ser concluídas no ciclo atual.",
  "Aulas não comparecidas e não utilizadas NÃO transitam para a cobrança do mês seguinte.",
];

export const GOOGLE_REVIEWS = [
  { name: "Júlia", rating: 5, text: "Profissional de qualidade, super recomendo!" },
  {
    name: "Giulia Thiemy",
    rating: 5,
    text: "Profissional dedicado, sempre atento à execução correta e à evolução do aluno. Treinos eficientes e bem organizados.",
  },
  { name: "Silvia Roberta", rating: 5, text: "Ótimo acompanhamento, evolução real a cada semana." },
  { name: "Laís Bertol", rating: 5, text: "Profissional top! Atendimento nota 10." },
  {
    name: "Amanda Paluski",
    rating: 5,
    text: "Personal muito atencioso e profissional, estou vendo muitos resultados com o acompanhamento dele.",
  },
  {
    name: "Luiz Wilhelm",
    rating: 5,
    text: "Excelente profissional, muito capacitado e muito gente boa. Recomendo demais!",
  },
];

export const FAQ_ONLINE = [
  {
    q: "Como funciona a consultoria online?",
    a: "Após o pagamento, você recebe em até 24h o formulário de anamnese. Depois de preenchido, entrego seu plano completo em até 72h, com treinos, protocolo alimentar e acesso ao app MFIT.",
  },
  {
    q: "Preciso ter experiência em academia?",
    a: "Não. Atendo do iniciante ao avançado. Cada planilha é construída respeitando seu nível atual, objetivos e limitações.",
  },
  {
    q: "Quais são as formas de pagamento?",
    a: "PIX e Boleto Bancário têm 10% de desconto à vista. Cartão de Crédito com parcelamento em até 3x sem juros (exceto plano Essencial, somente à vista).",
  },
  {
    q: "Em quanto tempo vejo resultados?",
    a: "Com constância, as primeiras mudanças aparecem em 4–6 semanas. Resultados expressivos vêm entre 3 e 6 meses — por isso os planos trimestrais e semestrais costumam ser os mais recomendados.",
  },
  {
    q: "O treino inclui dieta detalhada de nutricionista?",
    a: "Entrego um protocolo alimentar de orientação, não substitui o acompanhamento individual de um nutricionista. Para dietas clínicas específicas, recomendo buscar um profissional parceiro.",
  },
  {
    q: "Posso tirar dúvidas durante a semana?",
    a: "Sim! O suporte via WhatsApp é parte do plano. Nos planos Elite e Prime o suporte é prioritário.",
  },
  {
    q: "Consigo cancelar ou pausar o plano?",
    a: "Planos trimestrais, semestrais e anuais seguem o contrato de adesão. Pause e ajustes são avaliados caso a caso, priorizando seus resultados.",
  },
];

export const FAQ_PERSONAL = [
  {
    q: "Onde acontecem os treinos presenciais?",
    a: "Todos os treinos são realizados na Academia Estimoove — Av. República Argentina, 4194, Panorama, Foz do Iguaçu - PR.",
  },
  {
    q: "Quais são as formas de pagamento para o presencial?",
    a: "Dinheiro em espécie direto na academia e PIX — pagamentos mensais no início de cada ciclo.",
  },
  {
    q: "O que acontece se eu faltar a uma aula?",
    a: "As aulas são NÃO acumulativas. Aulas não comparecidas não transitam para o mês seguinte — por isso a agenda é combinada com antecedência para preservar seu progresso.",
  },
  {
    q: "Inclui avaliação física?",
    a: "Sim. Todos os planos incluem avaliação física periódica para ajustarmos o treino e medirmos sua evolução com métricas reais.",
  },
  {
    q: "Posso trocar de plano durante o mês?",
    a: "Sim, é possível fazer upgrade do plano mediante ajuste proporcional. Basta alinharmos antes da renovação.",
  },
  {
    q: "Quantos dias por semana devo treinar?",
    a: "Depende do seu objetivo. Bronze 2x/sem é ideal para quem começa; Prata 3x/sem é o equilíbrio clássico; Ouro 4x/sem acelera resultados; Black 5x/sem é para performance máxima.",
  },
];
